export const isInEnum = <Enum extends Record<string, string | number>>(
  enumType: Enum,
  value: unknown,
): value is Enum[keyof Enum] => {
  return Object.values(enumType).includes(value as Enum[keyof Enum]);
};
